import { createSelector } from 'reselect';
import { playerStatsSelector } from './simple-selectors';

export const playerStatsCustomFieldsSelector = createSelector(
    playerStatsSelector,
    (playerStats) => playerStats.customFields
);
